import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { getAssetCategory, getUploaderAssetThumbnail } from 'shared/digital-assets/digital-asset-helpers';


@Component({
  moduleId: module.id,
  selector: 'ecommerce-digital-asset',
  templateUrl: 'digital-asset.component.html',
  styleUrls: ['digital-asset.component.scss'],
})
export class DigitalAssetComponent extends BaseSegmentComponent implements OnInit, OnDestroy {

  groupedAssets: any;
  private subscription: Subscription;

  ngOnInit() {
    this.subscription = this.dataChange.subscribe(() => {
      this.setData();
    });
    this.setData();
  }

  ngOnDestroy() {
    if (this.subscription) {  this.subscription.unsubscribe(); }
  }

  getIcon(asset: any): string {
    return getUploaderAssetThumbnail(asset);
  }

  setData() {
    this.groupedAssets = _.groupBy(_.get(this.itemDetail, 'digitalAssets', []), (item) => {
      return getAssetCategory(item);
    });
  }
}
